export default "__VITE_ASSET__Dbn0bQ$Y__"